/***
 *
 *   CONTACT PROJECTS PANNEL
 *   Phase 7 — reference ContactProjectsSheet content, rendered through the
 *   live Pannel (not vaul/Sheet).
 *
 **********/

import React from 'react';
import { Table, EmptyState, Skeleton } from 'components/lib';
import { useTranslate } from 'app/translations';
import Style from './contactProjectsPannel.tailwind';

export function ContactProjectsPannel(props) {
    const { _t } = useTranslate();
    const {
        userName,
        userType,
        projects,
        loading,
        onAdd,
        onRemove,
        onEditRole,
        canManage,
    } = props;

    if (loading) {
        return (
            <div className={Style.shell}>
                <Skeleton className="h-8 w-2/3" />
                <Skeleton className="h-48 w-full" />
            </div>
        );
    }

    if (!projects?.length) {
        return (
            <div className={Style.shell}>
                <EmptyState
                    bare
                    icon="folder"
                    title={_t('contact.detail.noProjects')}
                    text={_t('contact.projects.manageDescription', { name: userName })}
                />
            </div>
        );
    }

    return (
        <div className={Style.shell}>
            <p className={Style.description}>
                {_t('contact.projects.manageDescription', { name: userName })}
            </p>

            <Table
                search
                className="restrict-width"
                data={projects}
                show={['name', 'role']}
                actions={{
                    custom: canManage
                        ? [
                              {
                                  title: _t(`project.${userType}.edit.label`),
                                  icon: 'edit',
                                  action: onEditRole,
                                  conditions: [
                                      { col: 'isInProject', value: true },
                                      {
                                          col: 'role',
                                          value: [
                                              _t(`project.roles.contact`),
                                              _t(`project.roles.admin`),
                                          ],
                                      },
                                  ],
                              },
                              {
                                  title: _t(`project.${userType}.remove.label`),
                                  icon: 'user-minus',
                                  action: onRemove,
                                  conditions: [{ col: 'isInProject', value: true }],
                              },
                              {
                                  title: _t(`project.${userType}.add`),
                                  icon: 'user-plus',
                                  action: onAdd,
                                  conditions: [{ col: 'isInProject', value: false }],
                              },
                          ]
                        : [],
                }}
            />
        </div>
    );
}
